// Manage My Booking sign-in: email and code validation, and the "Resend code" countdown.

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const CODE_PATTERN = /^\d{6}$/;

const emailForm = document.querySelector('[data-mmb-signin]');
if (emailForm) {
    validateOnSubmit(emailForm, 'email', (value) => EMAIL_PATTERN.test(value.trim()));
}

const codeForm = document.querySelector('[data-mmb-verify]');
if (codeForm) {
    const input = codeForm.elements.code;
    input.addEventListener('input', () => {
        const digits = input.value.replace(/\D/g, '').slice(0, 6);
        if (digits !== input.value) {
            input.value = digits;
        }
    });
    validateOnSubmit(codeForm, 'code', (value) => CODE_PATTERN.test(value.replace(/\D/g, '')));
}

const resend = document.querySelector('[data-mmb-resend]');
if (resend) {
    startResendCountdown(resend);
}

/**
 * Errors show after the first submit, then update as the user types. The server validates again.
 */
function validateOnSubmit(form, name, isValid) {
    const input = form.elements[name];
    const field = form.querySelector(`[data-mmb-field="${name}"]`);
    const error = field.querySelector('.mmb-field__error');
    const submit = form.querySelector('[type="submit"]');
    let tried = error.hidden === false;

    const check = () => {
        const ok = isValid(input.value);
        const show = tried && !ok;
        field.classList.toggle('mmb-field--error', show);
        input.setAttribute('aria-invalid', show ? 'true' : 'false');
        if (show) {
            error.textContent = error.dataset.mmbError;
        }
        error.hidden = !show;

        return ok;
    };

    input.addEventListener('input', () => {
        if (tried) {
            check();
        }
    });

    form.addEventListener('submit', (event) => {
        tried = true;
        if (!check()) {
            event.preventDefault();
            input.focus();
            return;
        }
        submit.disabled = true;
        submit.setAttribute('aria-busy', 'true');
    });
}

function startResendCountdown(button) {
    const countdown = document.querySelector('[data-mmb-resend-countdown]');
    const seconds = document.querySelector('[data-mmb-resend-seconds]');
    let remaining = Number(button.dataset.wait) || 0;
    if (remaining <= 0) {
        return;
    }

    const timer = window.setInterval(() => {
        remaining -= 1;
        if (seconds) {
            seconds.textContent = String(remaining);
        }
        if (remaining <= 0) {
            window.clearInterval(timer);
            button.disabled = false;
            if (countdown) {
                countdown.hidden = true;
            }
        }
    }, 1000);
}
